import React from 'react'
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
// import pdfBG from 'assets/images/fee-slip.png'
import QRCode from 'qrcode'

const pdfBG = "https://res.cloudinary.com/dkulkn9be/image/upload/v1759748991/guardHouse/guards/WhatsApp_Image_2025-10-02_at_9.05.24_PM_1_uscybq.jpg"

export default function PDF({ data }) {
    let { registrationNumber, email, fullName, phone, cnic, course = {}, campus = {}, amount, ref, createdAt, method, feeType, remarks } = data

    const qrCodeDataUrl = QRCode.toDataURL(`http://codevpk.com`);

    return (
        <Document
            title={`CoDev fee receipt for ${fullName}`}
            author={window.appName}
            subject={`CoDev fee receipt for ${fullName}`}
        >
            <Page size="A4" style={styles.page}>
                <View style={styles.pdfBG}><Image source={{ uri: pdfBG }}></Image></View>
                <Image src={qrCodeDataUrl} style={styles.photo} />
                <Text style={[styles.textSmall, { position: "absolute", top: 34, right: 194 }]}>{window.FormatPhoneNormal(campus.phone)}</Text>
                <Text style={[styles.textSmall, { position: "absolute", top: 54.5, right: 194 }]}>{window.FormatPhoneNormal(campus.whatsapp)}</Text>
                {/* <Text style={[styles.textSmall, { position: "absolute", top: 74, right: 122.5 }]}>{campus.address}</Text> */}
                <Text style={[{ position: "absolute", top: 74, right: campus.name === "Al Seeraht" ? 95 : 143.5, fontSize: campus.name === "Al Seeraht" ? 10 : 12, marginTop: campus.name === "Al Seeraht" ? 1 : 0 }]}>{campus.address}</Text>

                <View style={styles.content}>
                    <Text style={styles.textSmall}>{fullName}</Text>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={[styles.textSmallCapitalize, { marginTop: 1.5 }]}>{cnic}</Text>
                        </View>
                        <View style={[styles.col, styles.col2, { marginTop: 1.5 }]}>
                            <Text style={[styles.textSmallCapitalize]}>{window.FormatPhoneNormal(phone)}</Text>
                        </View>
                    </View>
                    <Text style={[styles.textSmall, { marginTop: 13 }]}>{email}</Text>
                    <Text style={[styles.textSmall, { marginTop: 13 }]}>{course.title} (Batch-{course.batch})</Text>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={styles.textSmallCapitalize}>{registrationNumber}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={[styles.textSmallCapitalize]}>{amount.toLocaleString()}</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={styles.textSmallCapitalize}>{window.toCapitalizeCase(method)}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={[styles.textSmallCapitalize]}>{window.toCapitalizeCase(feeType)}</Text>
                        </View>
                    </View>
                    <View style={[styles.row, { marginTop: 15 }]}>
                        <View style={styles.col}>
                            <Text style={styles.textSmallCapitalize}>{ref}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={[styles.textSmallCapitalize]}>{window.dateFormat(createdAt, "DD-MMM-YYYY")}</Text>
                        </View>
                    </View>
                    <Text style={[styles.textSmall, { marginTop: 14 }]}>{remarks}</Text>
                </View>
            </Page>
        </Document>
    )
}

const styles = StyleSheet.create({
    page: {
        backgroundColor: 'white',
        flexDirection: "column"
    },
    pdfBG: {
        position: "absolute",
        top: 0,
        width: "100%"
    },
    photo: {
        width: 73.5,
        height: 73.5,
        position: "absolute",
        top: 23.7,
        right: 20.2,
    },
    textSmall: {
        fontSize: 12
    },
    textWhite: {
        fontSize: 9,
        color: '#ffffff'
    },
    textSmallWhite: {
        fontSize: 7,
        color: '#ffffff'
    },
    textSmallCapitalize: {
        fontSize: 12,
        textTransform: "capitalize"
    },
    content: {
        width: 435,
        top: 145,
        left: 138,
    },
    row: {
        marginTop: 13,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    },
    col: {
        width: 162,
    },
    col2: {
        width: 152,
    },
    cardContent: {
        width: 441,
        top: 144,
        left: 138,
    },
    cardRow: {
        marginTop: 8,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center"
    },
    colR: {
        width: 180,
    },
    col2R: {
        width: 180,
    },
});